<template>
  <pagefra
    v-loading.fullscreen="deriveLoading"
    :element-loading-text="$l('生成中...')"
  >
    <div
      class="report-box"
      id="elevator-monthly"
      v-loading.fullscreen="loading"
    >
      <div class="report-item-box">
        <div class="report-title">
          <div class="title-l">
            <label class="back" v-if="!deriveLoading" @click="$router.go(-1)"
              ><i class="el-icon-arrow-left"></i>{{ $l("返回") }}
            </label>
            <strong>{{ $l("电梯基本信息") }} </strong>
            <span></span>
          </div>
          <div class="title-r">
            <el-button
              type="primary"
              round
              v-if="!deriveLoading"
              @click="handleDerive"
              class="download"
              >{{ $l("导出") }}
            </el-button>
          </div>
        </div>
        <div class="content-box">
          <div class="info-box">
            <div class="code-item">
              <span>{{ $l("所在城市：") }} {{ form.city }}</span>
            </div>
            <div class="code-item">
              <span>{{ $l("地盘名称：") }} {{ form.domainName }}</span>
            </div>
            <template v-if="isDomain">
              <div class="code-item">
                <span>{{ $l("报告确认时间：") }} {{ form.confirmTime }}</span>
              </div>
              <div class="code-item">
                <span class="ti-input"
                  >{{ $l("安全员/安全总监：") }}
                  <el-select
                    v-model="form.adminName"
                    :placeholder="$l('请选择')"
                    filterable
                    v-if="!deriveLoading"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in whiteListOptions"
                      :key="item.userName"
                      :label="item.userName"
                      :value="item.userName"
                    ></el-option>
                  </el-select>
                  <template v-else>{{ form.adminName }}</template>
                </span>
              </div>
              <div class="code-item">
                <span
                  >{{ $l("台量：") }}
                  {{ form.liftCount + form.escalatorCount }}</span
                >
              </div>
              <div class="code-item">
                <span>{{ $l("扶梯：") }} {{ form.escalatorCount }}</span>
              </div>
              <div class="code-item">
                <span>{{ $l("直梯：") }} {{ form.liftCount }}</span>
              </div>
            </template>
            <template v-else>
              <div class="code-item">
                <span>{{ $l("大楼名称：") }} {{ form.buildingName }}</span>
              </div>
              <div class="code-item">
                <span>{{ $l("梯号：") }} {{ form.elevatorNum }}</span>
              </div>
              <div class="code-item">
                <span>{{ $l("工号：") }} {{ form.jobNum }}</span>
              </div>
              <div class="code-item">
                <span>{{ $l("注册代码：") }} {{ form.registerCode }}</span>
              </div>
              <div class="code-item">
                <span>{{ $l("报告确认时间：") }} {{ form.confirmTime }}</span>
              </div>
              <div class="code-item">
                <span class="ti-input"
                  >{{ $l("安全员/安全总监：") }}
                  <el-select
                    v-model="form.adminName"
                    :placeholder="$l('请选择')"
                    filterable
                    v-if="!deriveLoading"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in whiteListOptions"
                      :key="item.userName"
                      :label="item.userName"
                      :value="item.userName"
                    ></el-option>
                  </el-select>
                  <template v-else>{{ form.adminName }}</template>
                </span>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="report-item-box" v-if="indexTableRows.length">
        <div class="content-box">
          <el-table
            class="index-table"
            :data="indexTableRows"
            border
            :span-method="getIndexTableSpan"
          >
            <el-table-column
              type="index"
              :label="$l('序号')"
              width="70"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('检查部位')"
              min-width="130"
              align="center"
            >
              <template slot-scope="scope">
                {{ $l(scope.row.section.name) }}
              </template>
            </el-table-column>
            <el-table-column :label="$l('检查内容')" min-width="260">
              <template slot-scope="scope">
                {{ $l(scope.row.item.name) }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('统计情况')"
              min-width="150"
              align="center"
            >
              <template slot-scope="scope">
                <span class="result-text">{{
                  formatIndexValue(scope.row.item.value)
                }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="section-bottom-box">
        <div class="report-item-box">
          <div class="report-title">
            <div class="title-l">
              <strong>{{ $l("巡检拍照情况") }} </strong>
            </div>
            <div class="title-r">
              <el-button
                v-if="files.length != 0 && !deriveLoading"
                type="primary"
                class="download"
                round
                @click="clickDownloadImg"
                >{{ $l("下载") }}
              </el-button>
            </div>
          </div>
          <div class="content-box">
            <div class="explain-box">
              <div class="img-item" v-for="(t, i) in files" :key="i">
                <img :src="t.url" />
                <div class="o">
                  <span @click="imgView()" v-if="!deriveLoading"
                    >{{ $l("预览") }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="report-item-box">
          <div class="report-title">
            <div class="title-l">
              <strong>{{ $l("巡检日志说明") }} </strong>
            </div>
          </div>
          <div class="content-box">
            <div class="explain-box">
              <el-input
                type="textarea"
                maxlength="200"
                resize="none"
                v-model="form.remark"
                v-if="!deriveLoading"
              >
              </el-input>
              <span v-else>{{ form.remark }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="report-item-box" v-if="files.length > 0 && deriveLoading">
        <div class="report-title">
          <div class="title-l">
            <strong>巡检拍照图片详情</strong>
          </div>
        </div>
        <div class="content-box">
          <div class="bigimg">
            <img :src="t.url" v-for="(t, i) in files" :key="i" />
          </div>
        </div>
      </div>
      <el-image-viewer
        v-if="showViewer"
        :url-list="viewfiles"
        :on-close="closeViewer"
      >
      </el-image-viewer>

      <div class="signature-area">
        <div class="sign-title-bar">
          <span class="sign-title">{{ $l("巡检人员签名") }}</span>
          <el-button
            type="primary"
            round
            size="small"
            @click="signVisible = true"
            class="sign-btn"
            v-if="!deriveLoading"
          >
            {{ signatureImg ? $l("重新签名") : $l("签名") }}
          </el-button>
        </div>
        <div class="sign-body">
          <img v-if="signatureImg" :src="signatureImg" class="sign-img" />
        </div>
      </div>
      <sign-dialog
        :visible.sync="signVisible"
        @confirm="onSignConfirm"
      ></sign-dialog>
    </div>
  </pagefra>
</template>

<script>
import dayjs from "dayjs";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
dayjs.extend(require("dayjs/plugin/weekOfYear"));
import global from "@/mixins/global.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { mapGetters } from "vuex";
import signDialog from "@/components/signDialog.vue";
export default {
  mixins: [global],
  components: { ElImageViewer, signDialog },
  data() {
    return {
      loading: false,
      params: {},
      form: {
        city: "",
        domainName: "",
        buildingName: "",
        elevatorNum: "",
        registerCode: "",
        jobNum: "",
        adminName: "",
        confirmTime: "",
        liftCount: "",
        escalatorCount: "",
        remark: "",
        noReportDays: 0,
        noReports: 0,
        data: {},
      },
      whiteListOptions: [],
      files: [],
      signatureImg: "",
      isSignature: false,
      signVisible: false,
      showViewer: false,
    };
  },
  computed: {
    ...mapGetters(["deriveLoading"]),
    viewfiles() {
      return this.files.map((v) => v.url);
    },
    isDomain() {
      return this.$route.path == "/report/daily";
    },
    /* 检查指标表格行：检查部位=一级key，检查内容=二级key */
    indexTableRows() {
      const source = this.form.data || {};
      const rows = [];
      Object.keys(source).forEach((sectionName) => {
        const sectionData = source[sectionName] || {};
        const itemNames = Object.keys(sectionData);
        itemNames.forEach((itemName, i) => {
          rows.push({
            section: { name: sectionName },
            item: { name: itemName, value: sectionData[itemName] },
            span: i === 0 ? itemNames.length : 0,
          });
        });
      });
      return rows;
    },
  },
  created() {
    const { query } = this.$route;
    this.params = query;
    if (query.startTime) {
      this.$route.meta.subtitle = this.isDomain
        ? `（${dayjs(query.startTime).format("YYYY年MM月DD日")}）`
        : query.reportType == 1
        ? `（${dayjs(query.startTime).format("YYYY年MM月DD日")} 至 ${dayjs(
            query.endTime
          ).format("YYYY年MM月DD日")}）`
        : `（${dayjs(query.startTime).format("YYYY年MM月")}）`;
    }
    this.loadReportData();
    this.loadWhiteList();
  },
  methods: {
    loadWhiteList() {
      this.$http
        .get(this.$apiConfig.get_elevator_inspection_white_list)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            this.whiteListOptions = result.data || [];
          }
        });
    },
    loadReportData() {
      this.loading = true;
      const url = this.isDomain
        ? this.$apiConfig.get_elevator_statistics_domain
        : this.$apiConfig.get_elevator_inspection_report;
      this.$http
        .get(url, {
          params: this.params,
        })
        .then((response) => {
          let result = response.data;
          this.loading = false;
          if (result.code == 0) {
            this.form = Object.assign({}, this.form, result.data);
            this.form.data = this.form.data || {};
            this.form.adminName = "";
            result.data.imageList = result.data.imageList || [];
            this.files = result.data.imageList.map((v) => {
              return {
                url: result.data.resourceServerUrl + v.imageUrl,
                image: v,
              };
            });
            this.signatureImg = result.data.signatureUrl
              ? result.data.resourceServerUrl + result.data.signatureUrl
              : "";
            this.isSignature = false;
            if (this.isDomain && this.form.noReports > 0) {
              return this.$alert(
                `${
                  this.$l("当天有") +
                  this.form.noReports +
                  this.$l("台梯未提交日报，请先提交日报！")
                }`,
                this.$l("提示"),
                {
                  confirmButtonText: this.$l("确定"),
                  callback: () => {
                    sessionStorage.setItem(
                      "elevator_report_list_info",
                      JSON.stringify({
                        openReportList: true,
                        jobNum: this.params.jobNum,
                        startTime: this.params.startTime,
                        endTime: this.params.endTime,
                      })
                    );
                    this.$router.push({
                      name: "elevator",
                      query: {},
                    });
                  },
                }
              );
            }
            if (this.form.noReportDays > 0) {
              let endTime = this.params.endTime;
              const today = new Date();
              const endDate = new Date(endTime);
              if (endDate > today) {
                endTime = this.$common.formatDate(today);
              }
              return this.$alert(
                `${
                  this.params.reportType == 1
                    ? this.$l("本周")
                    : this.$l("本月")
                }${
                  this.$l("有") +
                  this.form.noReportDays +
                  this.$l("天未提交日报，请先提交日报！")
                }`,
                this.$l("提示"),
                {
                  confirmButtonText: this.$l("确定"),
                  callback: () => {
                    sessionStorage.setItem(
                      "elevator_report_list_info",
                      JSON.stringify({
                        openReportList: true,
                        jobNum: this.params.jobNum,
                        startTime: this.params.startTime,
                        endTime: endTime,
                      })
                    );
                    this.$router.push({
                      name: "elevator",
                      query: {},
                    });
                  },
                }
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    /* 检查指标表格行（检查部位=一级key，检查内容=二级key） */
    getIndexTableSpan({ row, columnIndex }) {
      if (columnIndex === 1) {
        return row.span
          ? { rowspan: row.span, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
      return { rowspan: 1, colspan: 1 };
    },
    /* 统计情况列显示：数值直接显示，对象显示 正常：x 异常：x */
    formatIndexValue(value) {
      if (value == null) {
        return "";
      }
      if (typeof value === "object") {
        return Object.keys(value)
          .map((k) => `${k}：${value[k] != null ? value[k] : ""}`)
          .join("  ");
      }
      return String(value);
    },
    imgView() {
      this.showViewer = true;
    },
    closeViewer() {
      this.showViewer = false;
    },
    onSignConfirm(img) {
      this.signatureImg = img;
      this.isSignature = true;
    },
    /* 导出 */
    handleDerive() {
      if (!this.signatureImg) {
        return this.$message(this.$l("请先进行签名"));
      }
      if (!this.form.adminName) {
        this.$message.warning(this.$l("请选择安全员/安全总监"));
        return;
      }

      this.$store.commit("setDeriveLoading", true);

      this.$nextTick(async () => {
        const pageFraMain = document.getElementsByClassName("pagefra-main")[0];
        const reportBox = document.getElementById("elevator-monthly");
        const elMain = pageFraMain?.querySelector(".el-main");

        if (!pageFraMain || !reportBox) {
          this.$store.commit("setDeriveLoading", false);
          return this.$message.error(this.$l("导出失败，请重试"));
        }

        // 保存原始样式
        const originStyles = {
          reportBox: {
            height: reportBox.style.height,
            overflow: reportBox.style.overflow,
          },
          elMain: { overflow: elMain?.style.overflow || "" },
          pageFraMain: {
            overflow: pageFraMain.style.overflow,
            height: pageFraMain.style.height,
          },
        };

        try {
          // 1. 先展开容器
          reportBox.style.overflow = "visible";
          if (elMain) elMain.style.overflow = "visible";
          pageFraMain.style.overflow = "visible";

          // 2. 等待所有原始图片加载完成
          await this.waitImagesLoaded(reportBox);

          // 3. SVG 转图片（此时图片会替换 SVG，可能触发新的加载）
          const svgReplacements = await this.convertSvgToImages(reportBox);

          // 4. 关键：等待 SVG 转换后的新图片完全加载
          await this.waitImagesLoaded(reportBox);

          // 5. 强制回流，确保布局计算正确
          void reportBox.offsetHeight;

          // 6. 计算完整高度
          const signatureArea = pageFraMain.querySelector(".signature-area");
          const totalHeight =
            reportBox.scrollHeight + (signatureArea?.offsetHeight || 0);
          reportBox.style.height = totalHeight + "px";
          pageFraMain.style.height = totalHeight + "px";
          // 7. 再次等待图片加载（高度变化可能触发重排）
          await this.waitImagesLoaded(reportBox);
          await new Promise((resolve) => setTimeout(resolve, 100));
          // 8. 导出 PDF
          const canvas = await html2canvas(pageFraMain, {
            useCORS: true,
            backgroundColor: "#ffffff",
            scale: 2,
            logging: false,
            timeout: 60000,
          });

          this.savePdf(canvas);

          // 9. 恢复 SVG
          svgReplacements.forEach(({ parent, original, replacement }) => {
            if (parent?.contains(replacement))
              parent.replaceChild(original, replacement);
          });
        } catch (error) {
          console.error("导出失败:", error);
          this.$message.error(this.$l("导出失败，请重试"));
        }

        // 10. 恢复样式
        reportBox.style.height = originStyles.reportBox.height || "auto";
        reportBox.style.overflow = originStyles.reportBox.overflow || "";
        if (elMain) elMain.style.overflow = originStyles.elMain.overflow;
        pageFraMain.style.overflow = originStyles.pageFraMain.overflow || "";
        pageFraMain.style.height = originStyles.pageFraMain.height || "auto";

        this.$store.commit("setDeriveLoading", false);
      });
    },

    // 等待所有图片加载完成
    waitImagesLoaded(container) {
      const images = container.querySelectorAll("img");
      const imagePromises = Array.from(images).map((img) => {
        // 如果图片已经加载完成，直接返回
        if (img.complete && img.naturalHeight > 0) {
          return Promise.resolve();
        }
        // 否则等待加载
        return new Promise((resolve) => {
          let resolved = false;
          const done = () => {
            if (!resolved) {
              resolved = true;
              resolve();
            }
          };
          img.onload = done;
          img.onerror = done;
          // 超时保护
          setTimeout(done, 8000);
        });
      });
      return Promise.all(imagePromises);
    },

    // SVG 转图片 - 确保正确替换并等待加载
    convertSvgToImages(container) {
      const svgIcons = container.querySelectorAll(".svg-icon:not(.converted)");
      const replacements = [];

      return Promise.all(
        Array.from(svgIcons).map((svgEl) => {
          return new Promise((resolve) => {
            try {
              const rect = svgEl.getBoundingClientRect();
              const width = rect.width || 24;
              const height = rect.height || 24;

              if (width === 0 || height === 0) return resolve();

              const canvas = document.createElement("canvas");
              canvas.width = width * 2;
              canvas.height = height * 2;
              const ctx = canvas.getContext("2d");

              const cloneSvg = svgEl.cloneNode(true);
              cloneSvg.setAttribute("width", width);
              cloneSvg.setAttribute("height", height);
              cloneSvg.setAttribute("xmlns", "http://www.w3.org/2000/svg");

              const fillColor =
                window.getComputedStyle(svgEl).fill || "#5c5c5c";
              cloneSvg
                .querySelectorAll(
                  "path, circle, rect, polygon, line, polyline, ellipse"
                )
                .forEach((el) => {
                  const f = el.getAttribute("fill");
                  if (!f || f === "none" || f === "transparent") {
                    el.setAttribute("fill", fillColor);
                  }
                });

              const svgData = new XMLSerializer().serializeToString(cloneSvg);
              const url = URL.createObjectURL(
                new Blob([svgData], { type: "image/svg+xml;charset=utf-8" })
              );

              const img = new Image();
              img.onload = () => {
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                URL.revokeObjectURL(url);

                const imgEl = document.createElement("img");
                imgEl.src = canvas.toDataURL("image/png");
                imgEl.style.cssText = `width:${width}px;height:${height}px;display:inline-block;vertical-align:middle;`;
                imgEl.className = svgEl.className + " converted";
                imgEl.setAttribute("data-svg-replaced", "true");

                const parent = svgEl.parentNode;
                if (parent) {
                  replacements.push({
                    parent,
                    original: svgEl,
                    replacement: imgEl,
                  });
                  parent.replaceChild(imgEl, svgEl);
                }
                resolve();
              };
              img.onerror = () => {
                URL.revokeObjectURL(url);
                resolve();
              };
              img.src = url;
              setTimeout(resolve, 5000);
            } catch (e) {
              resolve();
            }
          });
        })
      ).then(() => {
        // 返回替换列表，并确保所有替换完成
        return replacements;
      });
    },
    // 保存 PDF
    savePdf(canvas) {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;

      // 直接用 imgHeight 判断是否超过一页
      if (imgHeight > pdfHeight) {
        // 超过一页，延长页面
        const customPdf = new jsPDF({
          orientation: "p",
          unit: "mm",
          format: [pdfWidth, imgHeight + 5],
        });
        customPdf.addImage(imgData, "PNG", 0, 0, pdfWidth, imgHeight);
        customPdf.save(this.getPdfFileName());
      } else {
        // 一页够用
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, imgHeight);
        pdf.save(this.getPdfFileName());
      }
    },
    // 获取 PDF 文件名
    getPdfFileName() {
      const title = this.$route.meta.title || "";
      const subtitle = this.$route.meta.subtitle || "";
      const name = this.isDomain
        ? this.form.domainName || ""
        : this.form.registerCode || "";
      return `${title}${subtitle}_${name}.pdf`;
    },
    clickDownloadImg() {
      this.files.forEach((v, i) => {
        const image = new Image();
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          const context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          const url = canvas.toDataURL("image/jpg"); // 图片 base64
          const a = document.createElement("a");
          a.download = "巡检图片_" + (i + 1) + ".jpg";
          a.href = url;
          const event = new MouseEvent("click");
          a.dispatchEvent(event);
        };
        image.src =
          v.url +
          (v.url.indexOf("?") > -1 ? "&time=" : "?time=") +
          new Date().valueOf();
      });
    },
  },
};
</script>

<style scoped lang="scss">
.report-box {
  padding: 20px;
  background-color: #f0f1f2;
  max-width: 100%;
  overflow-x: hidden;
}

.report-item-box {
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid #c7c7c7;
  margin-bottom: 18px;
  display: flex;
  flex-direction: column;

  .report-title {
    height: 66px;
    padding: 15px 20px;
    border-bottom: 1px solid #c7c7c7;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-l {
      color: #5c5c5c;

      strong {
        font-size: 18px;
        font-weight: 700;
        margin-right: 10px;
      }
    }
  }

  .content-box {
    padding: 15px 20px;

    span,
    label {
      font-size: 14px;
      color: #5c5c5c;
    }
  }
}

.info-box {
  display: flex;
  flex-wrap: wrap;

  .code-item {
    flex: 0 0 25%;
    line-height: 2.5;
  }
}

.index-table {
  /deep/.el-table__cell {
    padding: 6px 0;
  }
  .result-text {
    font-size: 14px;
    color: #35b6ae;
  }
}

.ti-input {
  display: flex;
  align-items: center;

  .el-input {
    width: 100px;
  }
}

.back {
  margin-right: 15px;
  cursor: pointer;
}

.section-bottom-box {
  display: flex;
  margin-top: 18px;
  gap: 18px;

  & > div {
    width: calc(50% - 9px);
    flex-shrink: 0;

    .report-item-box {
      margin-bottom: 0;
    }
  }
}

.explain-box {
  height: auto;
  min-height: 120px;
  display: flex;
  overflow-x: auto;

  /deep/.el-textarea {
    height: 100%;

    .el-textarea__inner {
      min-height: 120px !important;
    }
  }

  .img-item {
    width: 100px;
    margin-right: 20px;

    img {
      width: 100px;
      height: 100px;
    }

    .o {
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        color: #ff5733;
        cursor: pointer;
      }

      span:last-child {
        color: #07a89e;
      }
    }
  }
}

.signature-area {
  background: #fff;
  border-radius: 16px;
  border: 1px solid #c7c7c7;
  margin-bottom: 18px;

  .sign-title-bar {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;

    .sign-title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
    }

    .sign-btn {
      background-color: #35b6ae;
      border-color: #35b6ae;
      color: #fff;
    }
  }

  .sign-body {
    padding: 0 20px 20px;

    .sign-img {
      max-height: 80px;
      max-width: 200px;
      border: 1px dashed #dcdfe6;
      border-radius: 4px;
      padding: 4px;
      background: #fafafa;
    }
  }
}

.download {
  margin-left: 20px;
  background-color: #35b6ae;
  border-color: #35b6ae;
}
</style>
